import React from 'react';
import styles from './LoadingModal.scss';
import classNames from 'classnames/bind';
import ReactLoading from 'react-loading';
import {colorPalette} from '../../../../lib/variables';

const cx = classNames.bind(styles);

const LoadingModal = () => {
  return (
    <div className={cx('LoadingModal')}>
      <div className={cx('LoadingModal__box')}>
        <ReactLoading type={'spin'}
                      color={colorPalette.awairGray7}
                      height={'50px'}
                      width={'50px'}/>
      </div>
    </div>
  );
};

export default LoadingModal;


// WEBPACK FOOTER //
// ./src/app/nest/components/LoadingModal/LoadingModal.js